import React from 'react';
import { useRouteError, useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Paper, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Logo from '../components/shared/CasablancaLogo';

const Error = () => {
  const error: any = useRouteError();
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="60vh"
        pt={5}
      >
        <Paper elevation={3} style={{ padding: '20px', textAlign: 'center', width: '100%' }}>
          <Logo/>
          <Box m={2} display="flex" justifyContent="center" alignItems="center">
            <ErrorOutlineIcon style={{ fontSize: 60, marginRight: 10 }} />
            <Typography m={0} component="h1" variant="h5" gutterBottom>
              Hoppla!
            </Typography>
          </Box>
          <Typography component="p" variant="body1" gutterBottom>
            Entschuldigung, ein unerwarteter Fehler ist aufgetreten.
          </Typography>
          <Typography component="p" variant="body2" color="textSecondary">
            {error.statusText || error.message}
          </Typography>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleGoBack}
            style={{ marginTop: '20px' }}
          >
            Zurück (Go Back)
          </Button>
        </Paper>
      </Box>
    </Container>
  );
}

export default Error;
